import camelcase from "camelcase";
import {snakeKeys} from "./array";

// URL regex to match either ngage URLs (with and without IDs) or standard https/mailto/tel URLs
export const linkUrlRegex = /^((?=ngage).*:\/\/[^/]+(\/.+)?|((tel:|mailto:|https?:\/\/).+))$/;

export function concatenate(...classes: (false | null | undefined | string)[]) {
    return classes.filter(Boolean).join(" ");
}

export function truncate(string: string | null | undefined, length: number = 100): string | undefined {
    if (!string) {
        return undefined
    }

    return string.length > length ? `${string.substring(0, length)}...` : string;
}

export function toSnakeCase(string: string, separator: string = '_'): string {
    return string.replace(/\W+/g, " ")
        .split(/ |\B(?=[A-Z])/)
        .map(word => word.toLowerCase())
        .join(separator);
}

export function toCamelCase(string: string): string {
    return camelcase(string)
}

export function toPascalCase(string: string): string {
    return camelcase(string, {pascalCase: true})
}

export function toTitleCase(string: string): string {
    return string.replaceAll('_', ' ')
        .replaceAll('-', ' ')
        .replaceAll(/\w\S*/g, word => {
            return word.charAt(0).toUpperCase() +
                word.slice(1).toLowerCase();
        });
}

export function capitaliseFirstLetter(string: string): string {
    return string.charAt(0).toUpperCase() + string.slice(1);
}

export function maybeAddQuestionMark(text: string) {
    const questionStarters = /^(who|what|when|where|why|how|is|are|do|does|did|can|could|should|would|will|have|has)\b/i;
    return questionStarters.test(text.trim())
      ? text.trim().replace(/[.?!]?$/, "?")
      : text;
}

export function isUrl(string: string): boolean {
    let url;

    try {
        url = new URL(string)
    } catch (error) {
        return false
    }

    return ['http:', 'https:'].includes(url.protocol)
}

export function queryString(parameters?: object, defaults?: object): string {
    const definedProps = (object: object) => Object.fromEntries(
        Object.entries(object).filter(([_key, value]) => value !== undefined)
    );

    const allParameters = {
        ...definedProps(defaults || {}),
        ...definedProps(parameters || {})
    }

    return Object.entries(allParameters)
        .map(([key, value]) => `${key}=${value}`)
        .join('&')
}

export function parameters(parameters: object, defaults?: object): object {
    const mergedParams = Object.assign({}, defaults ?? {}, parameters);
    
    const filteredParams = Object.fromEntries(
      Object
        .entries(mergedParams)
        .filter(([_key, value]) => value !== undefined && value !== null && value !== '')
    );

    return snakeKeys(filteredParams);
}

export function humanFileSize(bytes: number, metric: boolean = true, places: number =1) {
    const thresh = metric ? 1000 : 1024;

    if (Math.abs(bytes) < thresh) {
        return bytes + ' B';
    }

    const units = metric
        ? ['kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
        : ['KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB'];
    let u = -1;
    const r = 10**places;

    do {
        bytes /= thresh;
        ++u;
    } while (Math.round(Math.abs(bytes) * r) / r >= thresh && u < units.length - 1);


    return bytes.toFixed(places) + ' ' + units[u];
}

export function classNames(...classes: Array<any>) {
    return classes.filter(Boolean).join(' ')
}